<style scoped lang="scss">
    .logistic_echart > div {
        height: 300px;
    }
    .logistic_total {
    display: flex;
    justify-content: space-between;
        & > span, .ivu-tooltip {
            width: 16%;
            text-align: center;
            padding: 10px;
            color: #fff;
            font-weight: bold;
            .ivu-tooltip-rel{
                width: 100%;
            }
        }
    }
</style>
<template>
    <div>
        <div class="right-button">
            <vFormItem label="创建时间" label-width="80" inline>
                <DatePicker type="daterange"
                            placement="bottom-end"
                            placeholder="Select date"
                            ref="createdAt"
                            :value="createdate"
                            @on-change="createTime"
                ></DatePicker>
            </vFormItem>
            <vFormItem label="项目" label-width="80" inline>
                <Select
                    style="width: 150px"
                    v-model="lineidlist"
                    multiple
                    filterable
                    clearable
                >
                    <Option
                        v-for="item in getNewProductList"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </vFormItem>
            <vFormItem label="来源" label-width="80" inline>
                <Select
                    style="width: 150px"
                    v-model="sourcelist"
                    multiple
                    filterable
                    clearable
                >
                    <Option
                        v-for="item in getSource"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </vFormItem>
            <vFormItem label="部门" label-width="80" inline>
                <vInput v-model="partment"></vInput>
            </vFormItem>
            <Button
                icon="ios-search"
                class="margin-left-20"
                type="primary"
                @click="submit"
                >确定</Button
            >
            <Button
                icon='md-refresh'
                class="margin-left-10"
                type="default"
                @click="reset"
                >重置</Button
            >
        </div>

        <div class="logistic_total">
            <Tooltip v-for="(item, index) in numberReport" :key="index" :content="item.title" :class="item.theme" placement="top">    
                <Icon class="margin-right-5" type="md-help-circle" />
                <span>{{ item.label }}: {{ item.value }}</span>
            </Tooltip>
        </div>

        <div class="logistic_echart margin-top-30 margin-bottom-20 clearfix">
            <div class="echart_pei1 width-50per pull-left"></div>
            <div class="echart_pei2 width-50per pull-left"></div>

            <div class="echart_bar width-100per pull-left"></div>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import mixin from './mixins'
import { HttpproductDevelopmentRecommend } from "@/service/proddevelop";

export default {
    mixins: [mixin],
    data(){
        return {
            createdate:[],
            lineidlist:[],
            sourcelist:[],
            partment:null,
            numberReport:[],
        }
    },
    computed:{
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
    },
    created(){
        this.getDetail()
    },
    methods:{
        getDetail(){
            this.createdate = [
                this.getDay(-30),
                this.getDay(0),
            ];
            this.submit()
            
        },
        submit(){
            HttpproductDevelopmentRecommend({
                startTime:this.createdate[0],
                endTime:this.createdate[1],
                lineIds:this.lineidlist,
                source:this.sourcelist,
                department:this.partment,
            }).then(res=>{
                console.log(res)
                // 总数按钮
                let index = 0;
                let initData = [
                        {label:'总计',value:0,theme:'danger',title:'不含草稿状态还未提交的单据'},
                        {label:'待审核',value:0,theme:'primary',title:'待审核'},
                        {label:'已审核',value:0,theme:'warning',title:'已审核'},
                        {label:'已驳回',value:0,theme:'success',title:'已驳回'},
                        {label:'待转预选单量',value:0,theme:'gary',title:'已审核从未转预选的单量'},
                        {label:'已取消',value:0,theme:'danger',title:'已取消'},
                    ];
                if(res.data.statusMap == null){
                    this.numberReport = initData;
                }else{
                    this.numberReport = []
                    initData.map(item=>{
                        for(let key in res.data.statusMap){
                            if(item.label == key){
                                item.value = res.data.statusMap[item.label];
                            }
                        }
                    })
                    this.numberReport = initData
                }

                // 做各个图形的转换数据
                let sourcedata = [],categorydata = [];
                
                for(let key in res.data.recommendMap){
                    console.log(key,res.data.recommendMap[key])
                    let data = {
                        name:key,
                        value:res.data.recommendMap[key]
                    }
                    sourcedata.push(data)
                }
                this.drawEchartPie1(sourcedata);

                for(let key in res.data.categoryMap){
                    let data = {
                        name:key,
                        value:res.data.categoryMap[key]
                    }
                    categorydata.push(data)
                }
                this.drawEchartPie2(categorydata); 

                let delay1 = [], delay2 = [];
                for (let key2 in res.data.departmentMap) {
                    delay1.push({label:key2,value:res.data.departmentMap[key2]})
                }
                delay2 = this.compareFN(delay1,'value')
                this.drawEchartBar2(delay2)
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        createTime(data){
            this.createdate = [
                data[0],
                data[1],
            ];
        },
        reset(){
            this.lineidlist = [];
            this.sourcelist = [];
            this.partment = null;
            this.getDetail()
        },
        drawEchartPie1(sourcedata) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei1"));
            if(sourcedata.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "推荐来源分布",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: "推荐来源分布",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: 10,
                        top: 20,
                        itemGap: 15,
                        itemWidth: 10,
                    },
                    color:['#2db7f5','#808695','#ed3f14','#19be6b','#f90'],
                    series : [
                        {
                            name: '推荐来源分布',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            data: sourcedata,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                }
                            }
                        }
                    ]
                });
            }
        },
        drawEchartPie2(categorydata) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei2"));
            if(categorydata.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "品类分布",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: "品类分布",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: 10,
                        top: 20,
                        itemGap: 15,
                        itemWidth: 10,
                    },
                    color:['#2db7f5','#f90','#808695','#19be6b','#ed3f14'],
                    series : [
                        {
                            name: '品类分布',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            data: categorydata,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                }
                            }
                        }
                    ]
                });
            }
        },
        drawEchartBar2(delay2) {
            delay2.reverse();
            let datelabel1=[],datevalue1=[];
            delay2.map(item=>{
                datelabel1.push(item.label)
                datevalue1.push(item.value)
            })
            const echart = Echarts.init(this.$el.querySelector(".echart_bar"));

            if(delay2.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "部门分布情况",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: "部门分布情况",
                        left: "center",
                    },
                    tooltip: { trigger: "axis" },
                    xAxis: {
                        type: "category",
                        data: datelabel1,
                        axisLabel: {
                            interval: 0,
                        },
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            name: "总数量",
                            data: datevalue1,
                            type: "bar",
                            color:'#ed3f14'
                        },
                    ],
                });
            }
        },
    }
}
</script>